import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware'

const initialState = {
  id: "",
  Basket: 0,
  ShoppingCart: [],
  User: "",
  Name: "",
  Email: "",
  Phone: "",
  SocialToken: "",
  Type: "",
  Token: "",
  Refresh: false,
}

export const useUserStore = create(persist((set, get) => ({
  userState: initialState,
  setUser: (user) => set((state) => ({ userState: user })),
  setUserState: (user) => set((state) => ({
    userState: { ...state.userState, ...user }
  })),
  clearUser: () => set((state) => ({ userState: initialState })),
}), {
  name: 'userStore',
  storage: createJSONStorage(() => localStorage),
}))